class VolicesCardSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.vcsReady === 'true') return;
    this.dataset.vcsReady = 'true';

    this.track = this.querySelector('[data-vcs-track]');
    this.link = this.querySelector('[data-vcs-link]');
    this.slides = Array.from(this.querySelectorAll('[data-vcs-slide]'));
    this.prev = this.querySelector('[data-vcs-prev]');
    this.next = this.querySelector('[data-vcs-next]');
    this.index = 0;
    this.dragged = false;
    this.touchStartX = 0;
    this.raf = 0;

    if (!this.track || this.slides.length < 2) return;

    this.prev?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index - 1);
    });

    this.next?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index + 1);
    });

    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.syncFromScroll());
    }, { passive: true });

    this.track.addEventListener('touchstart', (event) => {
      this.touchStartX = event.touches?.[0]?.clientX ?? 0;
      this.dragged = false;
    }, { passive: true });

    this.track.addEventListener('touchend', (event) => {
      const endX = event.changedTouches?.[0]?.clientX ?? this.touchStartX;
      if (Math.abs(endX - this.touchStartX) > 8) this.dragged = true;
    }, { passive: true });

    this.track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') {
        this.pointerStartX = event.clientX;
        this.dragged = false;
      }
    });

    this.track.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'mouse' && Math.abs(event.clientX - (this.pointerStartX ?? event.clientX)) > 8) {
        this.dragged = true;
      }
    });

    this.link?.addEventListener('click', (event) => {
      if (!this.dragged) return;
      event.preventDefault();
      event.stopPropagation();
      this.dragged = false;
    });

    this.updateState();
  }

  goTo(index) {
    if (!this.track || !this.slides.length) return;
    const target = Math.max(0, Math.min(index, this.slides.length - 1));
    this.index = target;
    this.track.scrollTo({ left: this.track.clientWidth * target, behavior: 'smooth' });
    this.updateState();
  }

  syncFromScroll() {
    if (!this.track?.clientWidth) return;
    const nextIndex = Math.max(0, Math.min(Math.round(this.track.scrollLeft / this.track.clientWidth), this.slides.length - 1));
    if (nextIndex !== this.index) {
      this.index = nextIndex;
      this.updateState();
    }
  }

  updateState() {
    this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
    if (this.prev) this.prev.disabled = this.index === 0;
    if (this.next) this.next.disabled = this.index === this.slides.length - 1;

    const preload = this.slides[this.index + 1]?.querySelector('img[loading="lazy"]');
    if (preload) preload.removeAttribute('loading');
  }
}

if (!customElements.get('volices-card-slider')) {
  customElements.define('volices-card-slider', VolicesCardSlider);
}